module.exports = __webpack_public_path__ + "img/placeholder.e4038578.svg";